import React from 'react';
import PropTypes from 'prop-types';

import { SmallDroppableColumn } from './SmallDroppableColumn';

const SmallGroupedColumns = props => (
  <React.Fragment>
    {props.columns.map((column, index) => {
      const columnTiles = props.getTiles(column.id);

      return (
        <SmallDroppableColumn
          key={index}
          columnNumber={index}
          columnId={column.id}
          tiles={columnTiles}
        />
      );
    })}
  </React.Fragment>
);

SmallGroupedColumns.propTypes = {
  columns: PropTypes.array.isRequired,
  getTiles: PropTypes.func.isRequired,
};

export default SmallGroupedColumns;
